/* eslint-disable import/first */
// --------------------------------- Imports ----------------------------- //
// ---------------------------------------------------------------------- //
// DOTENV
require('dotenv').config()
import React, { Component } from 'react';
import { persistor } from './redux/store';

// ---------------------------------------------------------------------- //
// --------------------------------- Components -------------------------- //

import RouteContainer from "./route-container";
import { PersistGate } from 'redux-persist/integration/react';
// ---------------------------------------------------------------------- //
// ---------------------------------------------------------------------- //

// ---------------------------------------------------------------------- //
class App extends Component {
  render() {
    return (
      <PersistGate loading={null} persistor={persistor}>
          <div className="App">
            <RouteContainer /> 
          </div> 
      </PersistGate>
    );
  }
}
// ---------------------------------------------------------------------- //


// ---------------------------------------------------------------------- //
// ---------------------------------------------------------------------- //

export default App;

// ---------------------------------------------------------------------- //
// ---------------------------------------------------------------------- //
